import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

const STATUS_FROM_BACKEND = { finished: 'closed' }

function fromBackendStatus(status) {
  return STATUS_FROM_BACKEND[status] ?? status
}

function mapSurvey(raw, fallbackId) {
  const id = raw._id ?? raw.id ?? fallbackId
  return {
    id,
    uuid: raw.uuid ?? raw._id ?? raw.id ?? fallbackId ?? null,
    name: raw.name || raw.title || '',
    description: raw.description ?? '',
    startDate: raw.startDate ? new Date(raw.startDate) : null,
    endDate: raw.endDate ? new Date(raw.endDate) : null,
    status: fromBackendStatus(raw.status ?? 'active'),
    collectIpAddress: raw.collectIpAddress ?? false,
    showCaptcha: raw.enableCaptcha ?? false,
    collectRespondentIdentification: raw.respondentIdentification ?? false,
    capturePhysicalStructure: Object.values(raw.physicalStructure ?? {}).some(Boolean),
    structureFields: Object.entries(raw.physicalStructure ?? {})
      .filter(([, enabled]) => enabled)
      .map(([key]) => key),
    versionUuid: raw.versionUuid ?? raw._id ?? raw.id ?? fallbackId ?? null,
    activeVersionUuid: raw.activeVersionUuid ?? raw.versionUuid ?? raw._id ?? raw.id ?? fallbackId ?? null,
    surveyJson: raw.surveyJson ?? { pages: [{ name: 'page1', elements: [] }] },
    languages: raw.languages ?? [],
    defaultLanguage: raw.defaultLanguage ?? null,
    totalRespondents: raw.totalRespondents ?? 0,
    createdAt: raw.createdAt,
    registrationCode: raw.registrationCode ?? null,
    offlineCapable: raw.offlineCapable ?? null,
  }
}

export async function getSurvey(id) {
  const url = SURVEY_ENDPOINTS.GET.replace(':id', id)
  const response = await apiClient('generic-survey').get(url)
  return mapSurvey(response.data.data, id)
}
